import type {
  SupportChannelGetApiData,
  SupportChannelGetApiResponses,
  SupportChannelListApiData,
  SupportChannelListApiResponses,
  SupportChannelStatsGetApiData,
  SupportChannelStatsGetApiResponses,
  SupportScheduleCreateApiData,
  SupportScheduleCreateApiResponses,
  SupportScheduleDeleteApiData,
  SupportScheduleDeleteApiResponses,
  SupportScheduleGetApiData,
  SupportScheduleGetApiResponses,
  SupportScheduleListApiData,
  SupportScheduleListApiResponses,
  SupportScheduleMemberCreateApiData,
  SupportScheduleMemberCreateApiResponses,
  SupportScheduleMemberDeleteApiData,
  SupportScheduleMemberDeleteApiResponses,
  SupportScheduleMemberGetApiData,
  SupportScheduleMemberGetApiResponses,
  SupportScheduleMemberListApiData,
  SupportScheduleMemberListApiResponses,
  SupportScheduleMemberPatchApiData,
  SupportScheduleMemberPatchApiResponses,
  SupportSchedulePatchApiData,
  SupportSchedulePatchApiResponses,
  SupportScheduleRotateApiData,
  SupportScheduleRotateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSupportScheduleUrls = {
  getPaginatedSupportSchedules: dataEndpoint<SupportScheduleListApiData, SupportScheduleListApiResponses>({
    getUrl: (queryParams) => apiUrl('support-schedules/', queryParams)
  }),
  getSupportSchedule: dataEndpoint<SupportScheduleGetApiData, SupportScheduleGetApiResponses>({
    getUrl: ({ scheduleId }) => apiUrl(`support-schedules/${scheduleId}/`)
  }),
  postSupportSchedule: responseEndpoint<SupportScheduleCreateApiData, SupportScheduleCreateApiResponses>({
    getUrl: () => apiUrl('support-schedules/'),
    getBody: (data) => data
  }),
  patchSupportSchedule: responseEndpoint<SupportSchedulePatchApiData, SupportSchedulePatchApiResponses>({
    getUrl: ({ scheduleId }) => apiUrl(`support-schedules/${scheduleId}/`),
    getBody: ({ scheduleId: _, ...body }) => body
  }),
  deleteSupportSchedule: dataEndpoint<SupportScheduleDeleteApiData, SupportScheduleDeleteApiResponses>({
    getUrl: ({ scheduleId }) => apiUrl(`support-schedules/${scheduleId}/`)
  }),
  postSupportScheduleRotate: responseEndpoint<SupportScheduleRotateApiData, SupportScheduleRotateApiResponses>({
    getUrl: ({ scheduleId }) => apiUrl(`support-schedules/${scheduleId}/rotate/`),
    getBody: ({ scheduleId: _, ...body }) => body
  }),
  getPaginatedSupportScheduleMembers: dataEndpoint<
    SupportScheduleMemberListApiData,
    SupportScheduleMemberListApiResponses
  >({
    getUrl: ({ scheduleId, ...queryParams }) => apiUrl(`support-schedules/${scheduleId}/members/`, queryParams)
  }),
  getSupportScheduleMember: dataEndpoint<SupportScheduleMemberGetApiData, SupportScheduleMemberGetApiResponses>({
    getUrl: ({ scheduleId, memberId }) => apiUrl(`support-schedules/${scheduleId}/members/${memberId}/`)
  }),
  postSupportScheduleMember: responseEndpoint<
    SupportScheduleMemberCreateApiData,
    SupportScheduleMemberCreateApiResponses
  >({
    getUrl: ({ scheduleId }) => apiUrl(`support-schedules/${scheduleId}/members/`),
    getBody: ({ scheduleId: _, ...body }) => body
  }),
  patchSupportScheduleMember: responseEndpoint<
    SupportScheduleMemberPatchApiData,
    SupportScheduleMemberPatchApiResponses
  >({
    getUrl: ({ scheduleId, memberId }) => apiUrl(`support-schedules/${scheduleId}/members/${memberId}/`),
    getBody: ({ scheduleId: _, memberId: __, ...body }) => body
  }),
  deleteSupportScheduleMember: dataEndpoint<
    SupportScheduleMemberDeleteApiData,
    SupportScheduleMemberDeleteApiResponses
  >({
    getUrl: ({ scheduleId, memberId }) => apiUrl(`support-schedules/${scheduleId}/members/${memberId}/`)
  }),
  getPaginatedSupportChannels: dataEndpoint<SupportChannelListApiData, SupportChannelListApiResponses>({
    getUrl: (queryParams) => apiUrl('support-channels/', queryParams)
  }),
  getSupportChannel: dataEndpoint<SupportChannelGetApiData, SupportChannelGetApiResponses>({
    getUrl: ({ supportChannelId }) => apiUrl(`support-channels/${supportChannelId}/`)
  }),
  getSupportChannelStats: dataEndpoint<SupportChannelStatsGetApiData, SupportChannelStatsGetApiResponses>({
    getUrl: (queryParams) => apiUrl('support-channels/stats/', queryParams)
  })
};
